import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import {
  Box,
  Button,
  Divider,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import Error from 'components/error'
import { PageHeader } from 'components/page-header'
import PgaHopeCardLink from './pga-hope-card-link'
import LegalPolicies from 'pages/account/account-details/legal-policies'
import useAccountDetailsStyles from 'pages/account/account-details/styles'
import { roles, withProtectedRoute } from 'lib/auth'
import { GET_STUDENTS_AND_INVITED_GUARDIANS } from './queries'
import { useStyles } from './styles'
import InviteGuardianModal from './components/invite-guardian-modal'
import InviteGuardianItem from './components/invited-guardian-item'
import AccountsTable from './accounts-table'

const StudentsPage = () => {
  const { data, loading, error, refetch } = useQuery(
    GET_STUDENTS_AND_INVITED_GUARDIANS,
  )
  const classes = useStyles()
  const accountClasses = useAccountDetailsStyles()
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)

  if (loading) return <LinearProgress />
  if (error) return <Error error={error} />

  const representatives = data?.currentUser?.representatives
  const minorStudents = representatives
    ?.map(rep => rep.student)
    .filter(student => student.isMinor)

  const invitedGuardians = data?.jrlGuardianInvitations || []
  const canAddGuardian = data?.currentUser?.attributes?.jrlPlayers?.length > 0

  const crumbs = [
    {
      label: 'Home',
      to: '/',
    },
  ]

  return (
    <>
      <PageHeader
        title="Accounts"
        crumbs={crumbs}
        backTo="/"
        actions={
          canAddGuardian ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsInviteModalOpen(true)}
            >
              Add Guardian
            </Button>
          ) : null
        }
      />
      <Box>
        <AccountsTable representatives={representatives} />
        {invitedGuardians.length > 0 && (
          <Box className={classes.invitedSection}>
            <Typography
              className={classes.overlineText}
              style={{ marginTop: '2rem' }}
              variant="overline"
              component="div"
            >
              Invited Guardians ({invitedGuardians.length})
            </Typography>
            <Divider style={{ width: '100%', marginBottom: '1rem' }} />
            {invitedGuardians.map(ig => (
              <InviteGuardianItem
                key={ig.id}
                invitedGuardian={ig}
                refetch={refetch}
              />
            ))}
          </Box>
        )}
        <Box className={classes.policiesSection}>
          <PgaHopeCardLink classes={accountClasses} />
          <LegalPolicies classes={accountClasses} />
        </Box>
      </Box>

      <InviteGuardianModal
        open={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
        students={minorStudents}
        refetch={refetch}
      />
    </>
  )
}

export default withProtectedRoute(StudentsPage, [roles.CONSUMER])
